import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Card,
  CardActions,
  CardMedia,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  Stack,
  Button,
  CardContent,
  Avatar
} from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import { useSelector } from "react-redux";
import Loader from "../../common/Loader";
import { Postrequestcall } from "../../request/Postrequest";
import {
  FETCH_TICKETS,
  FETCH_TICKETS_SHARED_WITH_SUPERVISOR,
  FETCH_TICKETSBY_USERID,
  FETCH_USER_AUTH_2,
  FETCH_USERS_2,
  GETUSERINFO,
  SAVE_TICKETS_SHARED_WITH_SUPERVISOR
} from "../../constant/Apipath";
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import HomeIcon from "@mui/icons-material/Home";
import CircularProgress from "@mui/material/CircularProgress";
import RefreshIcon from "@mui/icons-material/Refresh";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import ViewTicketModal from "./ViewTicketModal";
import { debounce, get } from "lodash";
import AvatarPlaceholder from "../../assets/images/avtar_placeholder.jpeg";
import { Getrequestcall } from "../../request/Getrequest";

const UserTickets = () => {
  const theme = useTheme();
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { loginData } = useSelector((state) => state.main);

  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [refreshing, setRefreshing] = useState(false);
  const [showTicket, setShowTicket] = useState(false);
  const [ticketFlag, setTicketFlag] = useState("view");
  const [editTicketData, setEditTicketData] = useState([]);
  const [selectedTicketData, setSelectedTicketData] = useState(null);

  const [status, setStatus] = useState("");

  const [workerInfo, setWorkerInfo] = useState({
    name: "",
    profileImage: "",
    email: ""
  });

  const [pageNo, setPageNo] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const PAGE_SIZE = 10;

  const isExpired = (expiryDate) => {
    if (!expiryDate || expiryDate === "") return false;
    return moment(expiryDate).isBefore(moment());
  };

  useEffect(() => {
    if (Number(id) !== Number(loginData?.userInformation?.UserId)) {
      if (typeof location?.state?.status === "undefined" || location?.state?.status === "") {
        fetchTicketsSharedWithSupervisor();
      } else {
        setWorkerInfo({
          name: location?.state?.userInfo?.userName,
          profileImage: location?.state?.userInfo?.pictureUrl || "",
          email: location?.state?.userInfo?.userEmail
        });
        if (location?.state?.status === "Accepted") {
          setStatus("Accepted");
          fetchUserTicket(1, "", false);
        } else if (location?.state?.status === "Pending") {
          setStatus(location?.state?.status);
        } else if (
          location?.state?.status === "Rejected" ||
          location?.state?.status === "Expired"
        ) {
          saveTicketsWithSupervisor();
          setStatus(location?.state?.status);
        }
      }
    }
  }, [id]);

  const fetchTicketsSharedWithSupervisor = async () => {
    setLoading(true);
    try {
      const getObj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: Number(loginData?.userInformation?.UserId),
        IncludeRecordNr: true,
        SearchList: [
          {
            userId: Number(id),
            supervisorId: Number(loginData?.userInformation?.UserId)
          }
        ],
        SortList: [
          {
            FieldName: "Id",
            Direction: "DESC"
          }
        ]
      };
      const getResponse = await Postrequestcall(
        FETCH_TICKETS_SHARED_WITH_SUPERVISOR,
        getObj,
        loginData?.accessToken
      );
      if (getResponse?.status === 201 || getResponse?.status === 200) {
        if (getResponse?.data?.data?.length === 0) {
          await getUserInfo();
          await saveTicketsWithSupervisor();
        } else {
          const getUserinfo = getResponse?.data?.data[0] || {};
          setWorkerInfo({
            name: getUserinfo?.userName,
            profileImage: getUserinfo?.pictureUrl || "",
            email: getUserinfo?.userEmail
          });
          setStatus(getUserinfo?.status);
          if (getUserinfo?.status === "Accepted") {
            await fetchUserTicket(1, "", false);
          } else if (getUserinfo?.status === "Pending") {
            setTickets([]);
          } else if (getUserinfo?.status === "Rejected" || getUserinfo?.status === "Expired") {
            await saveTicketsWithSupervisor();
          }
        }
      }
    } catch (error) {
      console.log("fetchTicketsSharedWithSupervisor Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const getUserInfo = async () => {
    try {
      let getUserinfo = await Postrequestcall(
        FETCH_USER_AUTH_2,
        { SearchList: [{ Id: Number(id) }] },
        loginData?.accessToken
      );
      if (getUserinfo?.status === 201) {
        let getUser = getUserinfo?.data?.data?.[0];
        setWorkerInfo({
          name: getUser?.firstName + getUser?.lastName || "",
          profileImage: getUser?.pictureUrl || "",
          email: getUser?.userEmail || ""
        });
      }
    } catch (error) {
      console.log("erro", error);
    }
  };

  const saveTicketsWithSupervisor = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            UserId: Number(id),
            SupervisorId: Number(loginData?.userInformation?.UserId),
            Status: "Pending"
          }
        ],
        UserId: Number(loginData?.userInformation?.UserId)
      };
      await Postrequestcall(SAVE_TICKETS_SHARED_WITH_SUPERVISOR, payload, loginData?.accessToken);
      setStatus("Pending");
    } catch (error) {
      console.log("saveTicketsWithSupervisor Error:", error);
    } finally {
      setLoading(false);
    }
  }, [id]);

  const fetchUserTicket = async (page = 1, searchText = "", isLoadMore = false) => {
    if (page === 1) {
      setLoading(true);
    }
    try {
      const getObj = {
        UserId: Number(id),
        PageNo: page,
        PageSize: PAGE_SIZE,
        SearchString: searchText
      };

      const response = await Postrequestcall(
        FETCH_TICKETSBY_USERID,
        getObj,
        loginData?.accessToken
      );

      if (response?.status === 200) {
        const newTickets = response?.data?.data || [];
        if (page === 1) {
          setTickets(newTickets);
        } else {
          setTickets((prev) => [...prev, ...newTickets]);
        }
        setHasMore(newTickets.length === PAGE_SIZE);
        setPageNo(page);
      }
    } catch (error) {
      console.log("fetchUserTicket Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const loadMoreTickets = async () => {
    await fetchUserTicket(pageNo + 1, search, true);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      setPageNo(1);
      setHasMore(true);
      fetchUserTicket(1, value, false);
    }, 500),
    []
  );

  const openTicket = (e, ticket) => {
    e.preventDefault();
    setTicketFlag("view");
    setShowTicket(true);
    setEditTicketData(ticket);
  };

  const isSearchActive = search.trim().length > 0;
  const showNoSearchResults = !loading && isSearchActive && tickets.length === 0;
  const SearchEmptyState = () => (
    <Box
      sx={{
        minHeight: "320px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2
      }}>
      <Card
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: 520,
          borderRadius: 3,
          border: "1px solid",
          borderColor: "divider",
          bgcolor: "#fafafa",
          p: { xs: 3, sm: 4 },
          textAlign: "center"
        }}>
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            bgcolor: "rgba(25, 118, 210, 0.08)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2
          }}>
          <SearchOffIcon sx={{ fontSize: 38, color: "primary.main" }} />
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 700 }} gutterBottom>
          No tickets found
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          We couldn&apos;t find any tickets matching "{search.trim()}". Try a different keyword.
        </Typography>
      </Card>
    </Box>
  );

  if (Number(id) === Number(loginData?.userInformation?.UserId)) {
    return <Navigate to="/tickets" replace />;
  }

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}>
        <Loader fullScreen />
      </Box>
    );
  }

  return (
    <>
      {/* Worker Info Card */}
      <Card
        elevation={3}
        sx={{
          borderRadius: 3,
          margin: "15px"
        }}>
        <CardContent style={{ padding: "15px" }}>
          <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
            <Avatar
              src={workerInfo?.profileImage || AvatarPlaceholder}
              imgProps={{
                onError: (e) => {
                  e.target.src = AvatarPlaceholder;
                }
              }}
              sx={{ width: 60, height: 60 }}>
              {workerInfo?.name?.charAt(0)}
            </Avatar>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                {workerInfo?.name}
              </Typography>
              <Typography variant="body1" sx={{ color: "text.secondary" }}>
                {workerInfo?.email}
              </Typography>
            </Box>
          </Stack>
        </CardContent>
      </Card>
      <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 0 }}>
        {status === "Pending" && (
          <Box
            sx={{
              minHeight: "calc(100vh - 220px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              px: 2
            }}>
            <Card
              elevation={3}
              sx={{
                maxWidth: 700,
                width: "100%",
                p: { xs: 3, md: 5 },
                textAlign: "center",
                borderRadius: 3,
                backgroundColor: "#FFF8E1",
                borderLeft: "5px solid #F9A825",
                position: "relative"
              }}>
              <Tooltip title="Check Request Status">
                <IconButton
                  disabled={refreshing}
                  sx={{
                    position: "absolute",
                    top: 16,
                    right: 16,
                    bgcolor: "#fff",
                    boxShadow: 1
                  }}>
                  {refreshing ? (
                    <CircularProgress size={20} />
                  ) : (
                    <RefreshIcon
                      onClick={async () => {
                        setRefreshing(true);
                        await fetchTicketsSharedWithSupervisor();
                        setRefreshing(false);
                      }}
                    />
                  )}
                </IconButton>
              </Tooltip>
              <Box
                sx={{
                  width: 90,
                  height: 90,
                  borderRadius: "50%",
                  backgroundColor: "rgba(255,255,255,0.6)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 3
                }}>
                <AccessTimeIcon
                  sx={{
                    fontSize: 55,
                    color: "#F9A825"
                  }}
                />
              </Box>
              <Typography variant="h4" sx={{ fontWeight: 700 }} gutterBottom>
                Access Request Submitted
              </Typography>
              <Typography
                variant="body1"
                
                sx={{color: "text.secondary", 
                  maxWidth: 550,
                  mx: "auto",
                  lineHeight: 1.8,
                  mb: 4
                }}>
                Thank you for your request to view this worker's tickets. Your request has been
                submitted successfully. Once the worker reviews and approves your request, you will
                be able to access and view all of their tickets.
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 4
                }}>
                <Button
                  variant="contained"
                  startIcon={<HomeIcon />}
                  onClick={() => navigate("/")}
                  sx={{
                    minWidth: 180,
                    borderRadius: "50px",
                    textTransform: "none",
                    fontWeight: 600,
                    py: 1.2
                  }}>
                  Go to Home
                </Button>
              </Box>
            </Card>
          </Box>
        )}
        {status === "Rejected" && (
          <Box
            sx={{
              minHeight: "calc(100vh - 220px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              px: 2
            }}>
            <Card
              elevation={3}
              sx={{
                maxWidth: 700,
                width: "100%",
                p: { xs: 3, md: 5 },
                textAlign: "center",
                borderRadius: 3,
                backgroundColor: "#FFF8E1",
                borderLeft: "5px solid #F9A825"
              }}>
              <Box
                sx={{
                  width: 90,
                  height: 90,
                  borderRadius: "50%",
                  backgroundColor: "rgba(255,255,255,0.6)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 3
                }}>
                <AccessTimeIcon
                  sx={{
                    fontSize: 55,
                    color: "#F9A825"
                  }}
                />
              </Box>

              <Typography variant="h4" sx={{ fontWeight: 700 }} gutterBottom>
                Access Request Rejected
              </Typography>

              <Typography
                variant="body1"
                
                sx={{color: "text.secondary", 
                  maxWidth: 550,
                  mx: "auto",
                  lineHeight: 1.8,
                  mb: 4
                }}>
                Your request to view this worker's tickets has been reviewed and declined by the
                worker.
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 4
                }}>
                <Button
                  variant="contained"
                  startIcon={<HomeIcon />}
                  onClick={() => navigate("/")}
                  sx={{
                    minWidth: 180,
                    borderRadius: "50px",
                    textTransform: "none",
                    fontWeight: 600,
                    py: 1.2
                  }}>
                  Go to Home
                </Button>
              </Box>
            </Card>
          </Box>
        )}
        {status === "Accepted" && (
          <>
            <TextField
              fullWidth
              size="small"
              placeholder="Search tickets..."
              value={search}
              onChange={(e) => {
                const value = e.target.value;
                setSearch(value);
                debouncedSearch(value);
              }}
              sx={{ margin: "15px 0" }}
            />
            <Box
              className="main-content-card-list"
              id="scrollableTicketList"
              sx={{
                overflow: "auto",
                height: "calc(100vh - 100px)"
              }}>
              {loading ? (
                <Loader fullScreen />
              ) : showNoSearchResults ? (
                <SearchEmptyState />
              ) : (
                <InfiniteScroll
                  dataLength={tickets.length}
                  next={loadMoreTickets}
                  hasMore={hasMore}
                  scrollableTarget="scrollableTicketList"
                  loader={
                    <Box sx={{ textAlign: "center", py: 2 }}>
                      <CircularProgress size={25} />
                    </Box>
                  }
                  endMessage={
                    tickets.length > 9 && (
                      <Typography sx={{ py: 2, color: "text.secondary" }} textAlign="center">
                        No more tickets found
                      </Typography>
                    )
                  }>
                  <Grid container spacing={{ xs: 1.5, md: 2 }}>
                    {tickets.map((ticket, index) => (
                      <Grid
                        key={ticket.id || index}
                        size={{
                          xs: 12,
                          sm: 6,
                          md: 6,
                          lg: 4,
                          xl: 3
                        }}>
                        <Card
                          className="pagelist-content"
                          sx={{
                            backgroundColor: isExpired(ticket.expiry) ? "#FABEBE" : "#FFFFFF"
                          }}
                          onClick={(e) => openTicket(e, ticket)}>
                          <CardMedia
                            component="img"
                            height="200"
                            image={ticket?.frontPictureUrl}
                            alt={ticket?.ticketType}
                          />

                          <CardActions
                            disableSpacing
                            sx={{
                              flexDirection: "column",
                              alignItems: "flex-start",
                              p: 2
                            }}>
                            <Typography variant="h6" sx={{ fontWeight: 600 }} gutterBottom>
                              {ticket?.ticketType}
                            </Typography>

                            <Typography variant="body2">Issued By: {ticket?.issuedBy}</Typography>

                            <Typography variant="body2">
                              Issued On:{" "}
                              {ticket?.issuedOn
                                ? moment(ticket.issuedOn).format("DD MMM YYYY")
                                : "-"}
                            </Typography>

                            <Typography
                              variant="body2"
                              sx={{ color: isExpired(ticket.expiry) ? "error" : "text.secondary" }}>
                              Expiry:{" "}
                              {ticket?.expiry
                                ? moment(ticket.expiry).format("DD MMM YYYY")
                                : "No Expiry"}
                            </Typography>
                          </CardActions>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </InfiniteScroll>
              )}
            </Box>
          </>
        )}
      </Box>

      {showTicket && (
        <ViewTicketModal
          openModal={showTicket}
          closeModal={() => setShowTicket(false)}
          editTicketData={editTicketData}
          setSelectedTicketData={setSelectedTicketData}
          ticketFlag={ticketFlag}
          setTicketFlag={setTicketFlag}
        />
      )}
    </>
  );
};

export default UserTickets;
